export async function hashPassword(value: string): Promise<string> {
  const trimmed = (value || '').trim()
  if (!trimmed) {
    return ''
  }

  if (typeof globalThis.crypto !== 'undefined' && globalThis.crypto?.subtle) {
    const enc = new TextEncoder()
    const data = enc.encode(trimmed)
    const digest = await globalThis.crypto.subtle.digest('SHA-256', data)
    return bufferToHex(digest)
  }

  const { createHash } = await import('crypto')
  return createHash('sha256').update(trimmed).digest('hex')
}

function bufferToHex(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer)
  let hex = ''
  bytes.forEach(byte => {
    hex += byte.toString(16).padStart(2, '0')
  })
  return hex
}
